<div class="register-shell">

<div class="register-bg"></div><div class="register-bg-overlay"></div>

<div class="container-fluid register-container">

<div class="wizard-roadmap" aria-label="Kayıt adımları">

    <ng-container *ngFor="let step of wizardSteps; let last = last">

        <div class="wizard-step" [class.active]="currentStep === step.id" [class.completed]="stepStatus[step.id] === 'success'" [class.has-error]="stepStatus[step.id] === 'error'" [attr.aria-current]="currentStep === step.id ? 'step' : null">

            <div class="wizard-step-number">{{ step.id }}<span class="step-error-icon" *ngIf="stepStatus[step.id] === 'error'" role="img" aria-label="Bu adımda hata var">!</span></div>

            <div class="wizard-step-label">{{ step.label }}<span class="roadmap-state" *ngIf="stepStatus[step.id] === 'success'">✓ Verify geçildi</span><span class="roadmap-state" *ngIf="stepStatus[step.id] === 'error'">Hata var</span></div>

        </div>

        <div class="wizard-line" *ngIf="!last" [class.completed]="stepStatus[step.id] === 'success'"></div>

    </ng-container>

</div>

<section class="wizard-page pricing-page"><div class="row g-0 align-items-stretch"><div class="col-12 col-xl-3"><aside class="pricing-hero"><div class="hero-content">

    <div class="hero-step">ADIM {{ currentStep }} / 3</div>

    <h1>{{ stepTitle }}</h1><p>{{ stepDescription }}</p>

    <div class="hero-feature-list"><div class="hero-feature" *ngFor="let feature of stepFeatures"><span class="hero-feature-icon" aria-hidden="true">✓</span><span>{{ feature }}</span></div></div>

    <div class="hero-progress" aria-live="polite"><div class="hero-progress-item" *ngFor="let step of wizardSteps" [class.verified]="stepStatus[step.id] === 'success'" [class.failed]="stepStatus[step.id] === 'error'" [class.current]="currentStep === step.id">

        <span class="hero-progress-number">{{ step.id }}<span class="step-error-icon" *ngIf="stepStatus[step.id] === 'error'" role="img" aria-label="Hata">!</span></span><div><strong>{{ step.label }}</strong><small>{{ getStepStatusText(step.id) }}</small></div>

    </div></div>

    <div class="hero-selected" *ngIf="selectedPackage"><small>SEÇİLEN PAKET</small><strong>{{ selectedPackage.name }} · {{ isCompany ? 'Şirket / Kurumsal' : 'Şahıs' }}</strong><span>{{ selectedPackage.isCustomPrice ? 'Özel Fiyat' : formatMoney(selectedPackage.monthlyPrice ?? 0) + ' / ay' }}</span></div>

</div></aside></div><div class="col-12 col-xl-9"><main class="pricing-content">


       <div class="pricing-heading-row">

                            <div>

                                <span class="context-label">

                                    {{ selectedApplicantType === 'company'

                                        ? 'ŞİRKET PAKETLERİ'

                                        : 'BİREYSEL PAKETLER' }}

                                </span>

                                <h2>

                                    {{ selectedApplicantType === 'company'

                                        ? 'Şirketiniz için doğru kapasiteyi seçin'

                                        : 'İhtiyacınıza uygun paketi seçin' }}

                                </h2>

                            </div>

                      

                        </div>


<section class="package-selection-step" *ngIf="currentStep === 1">

                        <!-- HESAP TİPİ -->
<div class="account-switch-panel">
    <div class="account-switch-heading">
        <div>
            <div class="account-switch-title">Hesap türünüzü seçin</div>
            <div class="account-switch-subtitle">
                Seçiminize göre paketler ve kayıt formundaki alanlar otomatik olarak düzenlenir.
            </div>
        </div>
        <span class="account-switch-hint">1 seçim yapın</span>
    </div>

    <div class="account-switch">
        <div class="row g-3">
            <div class="col-12 col-md-6">
                <button type="button"
                        class="account-switch-button w-100 h-100"
                        [class.active]="selectedApplicantType === 'individual'"
                        (click)="selectApplicantType('individual')">

                    <span class="account-switch-check"
                          [class.visible]="selectedApplicantType === 'individual'"
                          aria-hidden="true"></span>

                    <span class="account-switch-icon individual-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" role="img">
                            <circle cx="12" cy="7.2" r="3.2"></circle>
                            <path d="M5.5 20c.35-4.45 2.7-7 6.5-7s6.15 2.55 6.5 7"></path>
                        </svg>
                    </span>

                    <span class="account-switch-text">
                        <strong>Şahıs</strong>
                        <small>Kendi projeleriniz için bireysel kullanım</small>
                    </span>
                </button>
            </div>

            <div class="col-12 col-md-6">
                <button type="button"
                        class="account-switch-button w-100 h-100"
                        [class.active]="selectedApplicantType === 'company'"
                        (click)="selectApplicantType('company')">

                    <span class="account-switch-check"
                          [class.visible]="selectedApplicantType === 'company'"
                          aria-hidden="true"></span>

                    <span class="account-switch-icon company-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" role="img">
                            <path d="M4 21V7.5h10V21"></path>
                            <path d="M14 11h6v10"></path>
                            <path d="M7.5 11h2M7.5 14.5h2M7.5 18h2M12 11h.01M12 14.5h.01M17 14.5h.01M17 18h.01"></path>
                        </svg>
                    </span>

                    <span class="account-switch-text">
                        <strong>Şirket / Kurumsal</strong>
                        <small>Ekibiniz ve şirketiniz için profesyonel çözümler</small>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- PAKET BAŞLIĞI -->

                     
                        <!-- PAKETLER -->

                        <div class="row g-4 justify-content-center align-items-stretch package-row">

                            <div class="col-12 col-md-6 col-xl-3 d-flex"

                                 *ngFor="let package of filteredPackages">

                                <article class="package-card w-100 h-100"

                                         [ngClass]="package.theme"

                                         [class.recommended]="package.recommended">

                                    <div class="package-accent"></div>

                                    <div class="recommended-badge"

                                         *ngIf="package.recommended">

                                        En Popüler

                                    </div>

                                    <div class="package-card-header">

                                        <div class="package-icon">

                                            <span *ngIf="package.name === 'Free'">◆</span>

                                            <span *ngIf="package.name === 'Plus'">♛</span>

                                            <span *ngIf="package.name === 'Pro'">ϟ</span>

                                            <span *ngIf="package.name === 'Enterprise'">▥</span>

                                        </div>

                                        <div class="package-heading">

                                            <h3>{{ package.name }}</h3>

                                            <strong>{{ package.subtitle }}</strong>

                                        </div>

                                    </div>

                                    <div class="package-price">

                                        <ng-container *ngIf="!package.isCustomPrice">

                                            <strong>

                                                {{ formatMoney(package.monthlyPrice ?? 0) }}

                                            </strong>

                                            <span>/ ay</span>

                                        </ng-container>

                                        <ng-container *ngIf="package.isCustomPrice">

                                            <strong>Özel Fiyat</strong>

                                        </ng-container>

                                    </div>

                                    <p class="package-description">

                                        {{ package.description }}

                                    </p>

                                    <div class="package-divider"></div>

                                    <ul class="package-limit-list">

                                        <li>

                                            <span class="limit-icon">●</span>

                                            <span>Proje Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxProject) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">↔</span>

                                            <span>İstek Limiti / Ay</span>

                                            <strong>{{ formatLimit(package.limits.maxRequestNumber) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">◷</span>

                                            <span>İstek Zaman Aşımı</span>

                                            <strong>{{ formatLimit(package.limits.requestTimeout) }} sn.</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">◉</span>

                                            <span>Kredi Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxCredit) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">◇</span>

                                            <span>Token Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxToken) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">♙</span>

                                            <span>Kullanıcı Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxUser) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">▯</span>

                                            <span>Cihaz Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxDevice) }}</strong>

                                        </li>

                                        <li>

                                            <span class="limit-icon">⇩</span>

                                            <span>Uygulama İndirme Limiti</span>

                                            <strong>{{ formatLimit(package.limits.maxApplicationDownload) }}</strong>

                                        </li>

                                    </ul>

                                    <div class="mt-auto p-3">

                                        <button type="button"

                                                class="package-select-button w-100 m-0"

                                                (click)="selectPackage(package.id)">

                                            {{ getPackageButtonText(package) }}

                                            <span>→</span>

                                        </button>

                                    </div>

                                </article>

                            </div>

                        </div>

                        <!-- KARŞILAŞTIRMA -->

<div class="row g-4 mt-4 comparison-row"><div class="col-12">

<section class="comparison-table-wrapper" aria-labelledby="package-comparison-title">

<div class="comparison-section-heading"><h3 id="package-comparison-title">Paket Özelliklerini Karşılaştırın</h3><p>{{ selectedApplicantType === 'company' ? 'Şirketinizin ihtiyacına uygun kapasiteyi seçin.' : 'Kullanımınıza uygun kapasiteyi seçin.' }}</p><span class="comparison-account-badge">{{ selectedApplicantType === 'company' ? 'ŞİRKET' : 'USER' }}</span></div>

<div class="table-responsive"><table class="table comparison-table align-middle mb-0" [style.min-width.px]="300 + filteredPackages.length * 200">

<thead><tr><th scope="col">ÖZELLİKLER</th>

<th scope="col" *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'" [class.comparison-recommended]="package.recommended"><div class="comparison-plan-heading"><span class="comparison-popular" *ngIf="package.recommended">En Popüler</span><span class="comparison-plan-icon" aria-hidden="true">{{ package.name === 'Free' ? '◆' : package.name === 'Plus' ? '↗' : package.name === 'Pro' ? 'ϟ' : '▥' }}</span><span class="comparison-plan-name">{{ package.name }}</span></div></th></tr></thead><tbody>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">▱</span><span>Proje Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxProject) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">↔</span><span>İstek Limiti / Ay</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxRequestNumber) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">◷</span><span>İstek Zaman Aşımı</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.requestTimeout) }} sn.</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">◉</span><span>Kredi Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxCredit) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">◇</span><span>Token Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxToken) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">♙</span><span>Kullanıcı Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxUser) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">▯</span><span>Cihaz Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxDevice) }}</span></td></tr>

<tr><th scope="row"><span class="comparison-feature"><span class="comparison-feature-icon" aria-hidden="true">↓</span><span>Uygulama İndirme Limiti</span></span></th><td *ngFor="let package of filteredPackages" [class.comparison-free]="package.name === 'Free'" [class.comparison-plus]="package.name === 'Plus'" [class.comparison-pro]="package.name === 'Pro'" [class.comparison-enterprise]="package.name === 'Enterprise'"><span class="comparison-value">{{ formatLimit(package.limits.maxApplicationDownload) }}</span></td></tr>

</tbody></table></div></section></div></div>

</section>

<section class="account-page" *ngIf="currentStep === 2">            <div class="step-page-card">

                <div class="step-page-header">

                    <div>

                        <span class="context-label dark-label">ADIM 2 / 3</span>

                        <h2>Hesap bilgilerinizi tamamlayın</h2>

                        <p>

                            {{ isCompany

                                ? 'Şirket / Kurumsal hesap bilgilerinizi girin.'

                                : 'Şahıs hesabınız için temel bilgilerinizi girin.' }}

                        </p>

                    </div>

                    <div class="selected-package-summary" *ngIf="selectedPackage">

                        <span class="summary-caption">Seçilen Paket</span>

                        <strong>{{ selectedPackage.name }}</strong>

                        <small>

                            {{ selectedPackage.isCustomPrice

                                ? 'Özel Fiyat'

                                : formatMoney(selectedPackage.monthlyPrice ?? 0) + ' / ay' }}

                        </small>

                    </div>

                </div>

                <div class="account-type-summary">

                    <span class="account-type-dot"></span>

                    <div>

                        <small>Hesap Türü</small>

                        <strong>

                            {{ isCompany ? 'Şirket / Kurumsal' : 'Şahıs' }}

                        </strong>

                    </div>

                </div>

                <div class="registration-error" *ngIf="registerErrorMessage" role="alert">{{ registerErrorMessage }}</div>

                <div class="registration-error" *ngIf="formSubmitted && applicationForm.invalid" role="alert">Lütfen işaretlenen alanları kontrol edin ve tekrar deneyin.</div>

                <form [formGroup]="applicationForm"

                      (ngSubmit)="submitRegistration()"

                      novalidate>

                    <div class="row g-4">

                        <!-- ŞAHIS: AD SOYAD / ŞİRKET: FİRMA ADI -->

                        <div class="col-12 col-lg-6">

                            <label class="form-label" for="fullName">

                                {{ fullNameLabel }}

                            </label>

                            <input id="fullName"

                                   type="text"

                                   class="form-control"

                                   formControlName="fullName"

                                   [class.is-invalid]="isInvalid('fullName')"

                                   [placeholder]="fullNamePlaceholder">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('fullName')">

                                {{ isCompany

                                    ? 'Firma adı / ticari ünvan alanı zorunludur.'

                                    : 'Ad soyad alanı zorunludur.' }}

                            </div>

                        </div>

                        <!-- E-POSTA -->

                        <div class="col-12 col-lg-6">

                            <label class="form-label" for="email">

                                {{ isCompany ? 'Kurumsal E-posta' : 'E-posta Adresi' }}

                            </label>

                            <input id="email"

                                   type="email"

                                   class="form-control"

                                   formControlName="email"

                                   [class.is-invalid]="isInvalid('email')"

                                   [placeholder]="isCompany ? 'ornek\@firma.com' : 'ornek\@eposta.com'">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('email')">

                                Geçerli bir e-posta adresi girin.

                            </div>

                        </div>

                        <!-- ŞİRKETTE TELEFON GÖRÜNÜR -->

                        <div class="col-12 col-lg-6"

                             *ngIf="isCompany">

                            <label class="form-label" for="phone">

                                Firma Telefonu

                            </label>

                            <input id="phone"

                                   type="text"

                                   class="form-control"

                                   formControlName="phone"

                                   [class.is-invalid]="isInvalid('phone')"

                                   placeholder="+90 212 000 00 00">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('phone')">

                                Geçerli bir telefon numarası girin.

                            </div>

                        </div>

                        <!-- ŞİFRE -->

                        <div class="col-12 col-lg-6">

                            <label class="form-label" for="password">

                                Şifre

                            </label>

                            <input id="password"

                                   type="password"

                                   class="form-control"

                                   formControlName="password"

                                   [class.is-invalid]="isInvalid('password')"

                                   placeholder="En az 8 karakter">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('password')">

                                Şifre en az 8 karakter olmalıdır.

                            </div>

                        </div>

                        <!-- ŞİFRE TEKRAR -->

                        <div class="col-12 col-lg-6">

                            <label class="form-label" for="passwordRepeat">

                                Şifre Tekrar

                            </label>

                            <input id="passwordRepeat"

                                   type="password"

                                   class="form-control"

                                   formControlName="passwordRepeat"

                                   [class.is-invalid]="isInvalid('passwordRepeat') || (applicationForm.errors?.['passwordMismatch'] && (applicationForm.get('passwordRepeat')?.touched || formSubmitted))"

                                   placeholder="Şifrenizi tekrar girin">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('passwordRepeat')">

                                Şifre tekrar alanı zorunludur.

                            </div>

                            <div class="invalid-feedback d-block"

                                 *ngIf="applicationForm.errors?.['passwordMismatch'] && (applicationForm.get('passwordRepeat')?.touched || formSubmitted)">

                                Şifreler birbiriyle eşleşmiyor.

                            </div>

                        </div>

                        <!-- CAPTCHA -->

                        <div class="col-12 col-lg-6">

                            <label class="form-label" for="captcha">

                                Güvenlik Doğrulaması

                            </label>

                            <input id="captcha"

                                   type="text"

                                   class="form-control"

                                   formControlName="captcha"

                                   [class.is-invalid]="isInvalid('captcha')"

                                   placeholder="Doğrulama kodunu girin">

                            <div class="invalid-feedback"

                                 *ngIf="isInvalid('captcha')">

                                Güvenlik doğrulaması zorunludur.

                            </div>

                        </div>

                        <!-- ONAY -->

                        <div class="col-12">

                            <div class="consent-box"

                                 [class.invalid]="isInvalid('consent')">

                                <input class="form-check-input"

                                       type="checkbox"

                                       id="consent"

                                       formControlName="consent">

                                <label for="consent">

                                    Kullanım koşullarını ve gizlilik politikasını okudum, kabul ediyorum.

                                </label>

                            </div>

                        </div>

                    </div>

                    <div class="step-actions">

                        <button type="button"

                                class="btn-step-secondary"

                                (click)="previousStep()"

                                [disabled]="isSubmitting">

                            ← Geri

                        </button>

                        <button type="submit"

                                class="btn-step-primary"

                                [disabled]="isSubmitting">

                            <span *ngIf="!isSubmitting">Kaydı Tamamla →</span>

                            <span *ngIf="isSubmitting">Kaydediliyor...</span>

                        </button>

                    </div>

                </form>

            </div>

</section>

<section class="result-page" *ngIf="currentStep === 3">            <div class="result-card"

                 [class.success]="registerResult === 'success'"

                 [class.error]="registerResult === 'error'">

                <div class="result-icon">

                    {{ registerResult === 'success' ? '✓' : '!' }}

                </div>

                <span class="context-label dark-label">

                    ADIM 3 / 3

                </span>

                <h2 *ngIf="registerResult === 'success'">

                    Hesabınız başarıyla oluşturuldu

                </h2>

                <h2 *ngIf="registerResult === 'error'">

                    Kayıt işlemi tamamlanamadı

                </h2>

                <p *ngIf="registerResult === 'success'">

                    ANAMETA ONE hesabınız hazır. Giriş yaparak panelinize devam edebilirsiniz.

                </p>

                <p *ngIf="registerResult === 'error'">

                    {{ registerErrorMessage }}

                </p>

                <div class="result-summary"

                     *ngIf="selectedPackage">

                    <div>

                        <small>Hesap</small>

                        <strong>{{ isCompany ? 'Şirket / Kurumsal' : 'Şahıs' }}</strong>

                    </div>

                    <div>

                        <small>Paket</small>

                        <strong>{{ selectedPackage.name }}</strong>

                    </div>

                    <div>

                        <small>Fiyat</small>

                        <strong>

                            {{ selectedPackage.isCustomPrice

                                ? 'Özel Fiyat'

                                : formatMoney(selectedPackage.monthlyPrice ?? 0) + ' / ay' }}

                        </strong>

                    </div>

                </div>

                <div class="login-error"

                     *ngIf="loginErrorMessage">

                    {{ loginErrorMessage }}

                </div>

                <button type="button"

                        class="btn-step-primary result-button"

                        *ngIf="registerResult === 'success'"

                        (click)="goToDashboard()"

                        [disabled]="isLoggingIn">

                    {{ isLoggingIn ? 'Giriş Yapılıyor...' : 'ANAMETA ONE’a Devam Et →' }}

                </button>

                <button type="button"

                        class="btn-step-secondary result-button"

                        *ngIf="registerResult === 'error'"

                        (click)="returnToAccount()">

                    Bilgileri Kontrol Et

                </button>

            </div>

</section>

</main></div></div></section>

</div></div>
